import { Outlet, Navigate, useLocation } from "react-router-dom";

const PrivateRoutes = () => {
  const ps10005000 = JSON.parse(localStorage.getItem("ps10005000"));
  const location = useLocation();

  return ps10005000 ? (
    <Outlet />
  ) : (
    <Navigate replace to="/" state={{ from: location }} />
  );
};

export default PrivateRoutes;
